<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">

        </navbar-toggle-button>
      </div>
      <a class="navbar-brand" href="#">Hệ thống điều khiển tưới tiêu từ xa</a>

    </div>


    <template slot="navbar-menu">
              <div class="messageStatus">       
        <p>{{message}}</p>      
      </div>   
      <div class="generalStatus" style="margin-right:15px;">       
        <p v-bind:class="{ active: gateErr, error: !gateErr }"> Gateway :  {{gateway}}&nbsp;&nbsp;&nbsp;&nbsp;</p>      
        <p v-bind:class="{ active: servErr, error: !servErr }"> Server :  {{server}}</p>
      </div>
      <div class="generalStatus" style="margin-right:15px">
        <p> H(%): {{airHumidity}} &nbsp;&nbsp;&nbsp;&nbsp;</p>
        <p> Độ ẩm đất (%) : {{groundHumidity}}</p>
      </div>
      <div>        
        <p> T(°C) : {{temperature}} &nbsp;&nbsp;&nbsp;</p>
      </div> 
    </template>
  </navbar>
</template>
<script>
  import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'

  export default {
    components: {
      Navbar,
      NavbarToggleButton
    },
    data() {
      return {
        timer: '',
        showNavbar: false,
        gateway: '1',
        gateErr: false,
        servErr: false,
        server: '1',
        temperature: '0',
        airHumidity: '0',
        groundHumidity: '0',
        message:'',
      }
    },
    created(){
    this.loadData();
    this.timer = setInterval(this.loadData, 5000);     // Refresh data after 5s
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },
      loadData() {
        const that = this;
        this.axios.get('LoraNode/LoRaTemp').then(response => {     
          // console.log(response.data);             
          that.$data.gateway = response.data.gateway;
          that.$data.servErr = true;            
          that.$data.server = 'ON';
          that.$data.temperature = response.data.temp;
          that.$data.airHumidity = response.data.humi;
          that.$data.groundHumidity = response.data.mois / 24 * 100;
          if (that.$data.gateway == 0 && response.data.status == 0) {
            that.$data.gateway = 'ON';
            that.$data.gateErr = true;
            that.$data.servErr = true;            
            that.$data.server = 'ON';
            if (response.data.mois > 70){
              that.$data.message = 'Hệ thống tạm ngưng do độ ẩm đất vượt quá 70%';
            }
            else that.$data.message = 'Hệ thống hoạt động bình thường';
          } else {
            that.$data.temperature = '--';
            that.$data.airHumidity = '--';
            that.$data.groundHumidity = '--';
            if (that.$data.gateway == 1) {
              that.$data.gateway = 'OFF';
              that.$data.gateErr = false;
              that.$data.message = 'Hệ thống không hoạt động';
            } else {
              that.$data.gateway = 'ON';
              that.$data.gateErr = true;
              that.$data.message = 'Hệ thống hoạt động bình thường';
            }
          }
          
        }).catch(error => {
          console.log(error);
          that.$data.temperature = '--';
          that.$data.airHumidity = '--';
          that.$data.groundHumidity = '--';
          that.$data.server = 'OFF';
          that.$data.servErr = false;
          that.$data.gateway = 'OFF';
          that.$data.gateErr = false;
        });
      }
    }
  }

</script>
<style scoped>
.generalStatus {
  word-wrap: break-word;
  width: 180px;
  display: block;
}

.messageStatus {
  word-wrap: break-word;
  width: 280px;
  display: block;
}

.navbar-wrapper {
  width: 100%;
}
.active {
  color: green;
}

.error {
  color: red;
}
</style>
